const rowStyle = {
    // width: '100%',
    display: "flex",
    flexFlow: "row wrap"
};
const colStyle = {
};
const gutter = 16;
export const basicStyle = {
    rowStyle,
    colStyle,
    gutter
};
